/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/prefer-default-export */
import React, { useState } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Slide from '@material-ui/core/Slide';
import Alert from '@material-ui/lab/Alert';

import './Snackbar.scss';

export enum Severity {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning',
}

export const withSnackbar = (WrappedComponent: any) => {
  return (props: any) => {
    const [open, setOpen] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("I'm a custom snackbar");
    const [duration, setDuration] = useState<number>(6000);
    const [severity, setSeverity] = useState<Severity>(Severity.SUCCESS);

    const showMessage = (msg: string, sev = Severity.SUCCESS, dur = 6000) => {
      setMessage(msg);
      setSeverity(sev);
      setDuration(dur);
      setOpen(true);
    };

    const handleClose = (
      _event: React.SyntheticEvent | React.MouseEvent,
      reason?: string
    ): void => {
      if (reason === 'clickaway') {
        return;
      }

      setOpen(false);
    };

    return (
      <>
        <WrappedComponent {...props} showSnackbar={showMessage} />
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          autoHideDuration={duration}
          open={open}
          onClose={handleClose}
          TransitionComponent={Slide}
        >
          <Alert variant="filled" onClose={handleClose} severity={severity}>
            {message}
          </Alert>
        </Snackbar>
      </>
    );
  };
};
